import {all} from 'redux-saga/effects';
import {photoBoothSaga} from './photoBooth';
import {gallerySaga} from './gallery';
import {routerSaga} from './router';
import {userSaga} from './user';

export function* rootSaga() {
  yield all([photoBoothSaga(), gallerySaga(), userSaga(), routerSaga()]);
}
